export let fileStore: Record<string, File> = {};
export const addFiletoStore = (pathKey: string, file: File): void => {
    fileStore[pathKey] = file;
};

export const clearFileStore = (): void => {
    for (const key in fileStore) {
        delete fileStore[key];
    }
};
export const deleteFile = (pathKey: string) => {
    if (pathKey in fileStore) delete fileStore[pathKey];
};
export const renameFileKeyInStore = (oldKey: string, newKey: string): void => {
    if (fileStore.hasOwnProperty(oldKey)) {
        fileStore[newKey] = fileStore[oldKey];
        delete fileStore[oldKey];
    }
};
export const setFileStore = (newFiles: any): void => {
    fileStore = { ...newFiles };
};

export const logFileStore = () => {
    console.log("Current fileStore contents:");
    Object.entries(fileStore).forEach(([key, file]) => {
        console.log(`- ${key}: ${file.name} (${file.type})`);
    });
};
